import React, { PureComponent } from 'react';
import { styled, Colors } from 'themes';
import SvFlag from './assets/svFlag.png';
import { device } from 'themes/media-queries';
import { withTranslation } from 'react-i18next';

class LinkTexting extends PureComponent {
  state = {
    number: '',
    sent: false,
  };

  onChange = event => {
    const { value } = event.target;
    const formattedValue = value.trim();
    const numbersOnly = /^[0-9\b]+$/;

    if (formattedValue === '' || numbersOnly.test(formattedValue)) {
      this.setState({
        number: formattedValue,
      });
    }
  };

  postData = event => {
    event.preventDefault();

    const { number, sent } = this.state;

    if (sent) return;

    const url = 'https://api.linktexting.com/sendLink';
    const linkId = '76940c6f-3906-4043-bb55-1e2ab6282084';

    this.setState({
      sent: true,
    });

    fetch(url, {
      method: 'POST',
      mode: 'cors',
      cache: 'no-cache',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        Origin: 'https://www.yepstr.com',
        Referer: 'https://www.yepstr.com',
      },
      body: `linkId=${linkId}&number=+46${number.replace(
        /^0+/,
        ''
      )}&countryCode=se`,
    })
      .then(response => response.json()) // parses response to JSON
      .then(response => console.log('repsonse', response)); // parses response to JSON
  };

  render() {
    const { t } = this.props;
    const { number, sent } = this.state;

    return (
      <Wrapper onSubmit={this.postData}>
        <InputWrapper>
          <img src={SvFlag} alt={'Swedish flag'} />
          <Input
            required={true}
            disabled={sent}
            placeholder={t('linktexting.placeholder')}
            type={'tel'}
            value={number}
            onChange={this.onChange}
          />
        </InputWrapper>
        <Button className="linkTextingButton" type={'submit'}>
          {sent
            ? t('linktexting.buttonLabel--sent')
            : t('linktexting.buttonLabel')}
        </Button>
      </Wrapper>
    );
  }
}

const Wrapper = styled.form`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${Colors.white};
  height: 6rem;
  max-width: 60rem;
  width: 100%;
  padding: 3px 3px 3px 8px;
  border-radius: 3px;
  box-shadow: 0 0.5rem 2rem 0 rgba(43, 44, 61, 0.15);

  ${device.mobileL} {
    display: flex;
  }
`;

const InputWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  img {
    margin-right: 3rem;

    @media ${device.mobileL} {
      margin-right: 1rem;
    }
  }
`;
const Input = styled.input`
  outline: none;
  border: none;
  font-size: 2.2rem;

  &:disabled {
    background-color: transparent;
  }

  @media ${device.mobileL} {
    font-size: 1.4rem;
  }
`;

const Button = styled.button`
  display: block;
  border-radius: 3px;
  border: none;
  height: 100%;
  outline: none;
  padding: 3px 1rem;
  font-weight: 700;
  font-size: 1.7rem;

  background-image: linear-gradient(
    255deg,
    ${Colors.orange},
    ${Colors.darkOrange}
  );
  color: white;

  &:active {
    background-image: linear-gradient(
      255deg,
      ${Colors.darkOrange},
      ${Colors.darkOrange}
    );
    box-shadow: none;
  }

  &:hover {
    box-shadow: 0 0.5em 2em 0 rgba(43, 44, 61, 0.15);
  }

  @media ${device.mobileL} {
    font-size: 1.2rem;
    width: 8rem;
  }
`;

export default withTranslation()(LinkTexting);
